import { type ExtensionAttributes } from './generated/ExtensionAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Extension extends ExtensionAttributes {}

@model
class Extension extends ApplicationModel {
  // Start auto-generated
  static typename: 'Extension' = 'Extension';
  get typename(): 'Extension' {
    return 'Extension';
  }

  static internalTypename: 'Extension' = 'Extension';
  get internalTypename(): 'Extension' {
    return 'Extension';
  }

  static fields = {
    createdAt: attr({ readable: true }),
    enabled: attr({ readable: true }),
    id: attr({ readable: true }),
    identifier: attr({ readable: true }),
    name: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    extensionContributions: attr.hasMany({
      args: { filters: 'ExtensionContributionFilters' },
      readable: true,
    }),
  };
  // End auto-generated
}

export default Extension;
